import { baseApi } from '../../app/baseApi';
import { baseQuery } from "../../app/baseQuery";
import { apiTags } from '../../app/store/apiTags';

const getCacheKey = (args) => {
    return `${args.id}`
}

const apiPrefix = 'tenant';
export const tenantApi = baseApi.injectEndpoints({
    reducerPath: 'tenantApi',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getTenants: builder.query({
            query: () => `${apiPrefix}`,
            providesTags: [apiTags.TENANTS],
        }),
        getTenant: builder.query({
            query: (id) => `${apiPrefix}/${id}`,
            providesTags: (result, error, arg) => [
                { type: apiTags.LOAD_GROUP, id: getCacheKey({ groupId: arg }) }
            ]
        }),
        createTenant: builder.mutation({
            query: tenant => ({
                url: `${apiPrefix}`,
                method: "POST",
                body: tenant
            }),
            invalidatesTags: (result, error, arg) => [
                apiTags.TENANTS
            ],
        }),
        updateTenantConfig: builder.mutation({
            query: ({ tenantId, tenantFeatureFlags,tenantDispatchInformation }) => ({
                url: `${apiPrefix}/config`,
                method: "PUT",
                body: {
                    tenantId,
                    tenantFeatureFlags,
                    tenantDispatchInformation
                }
            }),
            invalidatesTags: (result, error, arg) => [
                apiTags.TENANTS
            ],
        }),
    })
});

export const { useGetTenantsQuery, useGetTenantQuery, useCreateTenantMutation, useUpdateTenantConfigMutation } = tenantApi;